export const UPLOAD_CA = 'ipfabric/FileUploadOverlay/UPLOAD_CA';
